const {
  REACT_APP_URL: APP_URL,
  REACT_APP_FB_APP_ID: FBID,
  REACT_APP_GOGOLE_CLIENT_ID: GOOGLEID,
} = process.env;

export const isBuilding = () => navigator.userAgent === 'ReactSnap';

export const judgeTheBroswer = () => {
  const u = navigator.userAgent,
    isLineApp = u.indexOf("Line") > -1, // Line 內建瀏覽器
    isFbApp = u.indexOf("FBAV") > -1; // FB App 內建瀏覽器
  // 如果是 Line 內建瀏覽器
  if (isLineApp) {
    window.alert("LINE");
  }

  // 如果是 FB App 內建瀏覽器
  if (isFbApp) {
    window.alert("FB");
  }
};

export const isDailyAdult = () => isBuilding() || !!document.cookie.includes('status=SBWover18');

export const setDailyAdult = () => {
  document.cookie = "status=SBWover18; expires=" + new Date(+new Date() + 86400000).toUTCString();
};

export const setResult = (result: 'win' | 'lose') => {
  document.cookie = `result=${result}; expires=` + new Date(+new Date() + 60000).toUTCString();
};

export const isAgreePrivate = () => isBuilding() || !!document.cookie.includes('AgreePrivate=true');

export const setAgreePrivate = () => {
  document.cookie = "AgreePrivate=true; expires=" + new Date(+new Date() + 86400000 * 90).toUTCString();
};

export const isPhoneLogin = () => isBuilding() || !!document.cookie.includes('PhoneLogin=true');

export const setPhoneLogin = () => {
  document.cookie = "PhoneLogin=true; expires=" + new Date(+new Date() + 86400000 * 90).toUTCString();
};

export const getCookie: {(): {[key: string]: string}} = () => {
  return document.cookie.split('; ').reduce((obj, value) => {
    const [key, ...v] = value.split('=');
    return ({
      ...obj,
      [key]: v.join('=')
    });
  }, {});
};

export const getResult = () => {
  const cookies = getCookie();
  return cookies.result;
};

export const getGoogleRedirect = () => {
  const cookies = getCookie();
  return cookies.googleRedirect;
};


export const currentTime = () => {
  const d = new Date();
  function pad2(n: number) {
    return (n < 10 ? '0' : '') + n;
  }

  return d.getFullYear() + "-" +
          pad2(d.getMonth() + 1) + "-" +
          pad2(d.getDate()) + " " +
          pad2(d.getHours()) + ":" +
          pad2(d.getMinutes()) + ":" +
          pad2(d.getSeconds());
};

export const loginFBLink = (location: string) => {
  const HOST = APP_URL || "https://localhost:8080";
  return `https://www.facebook.com/v10.0/dialog/oauth?client_id=${FBID}&redirect_uri=${HOST}/auth-fb/&scope=email&state=${location}&response_type=token`;
};

export const loginGoogleLink = (location: string) => {
  const HOST = APP_URL || "https://localhost:8080";
  document.cookie = `googleRedirect=${location}; expires=` + new Date(+new Date() + 60000).toUTCString();
  localStorage.setItem('googleRedirect', location);

  return `https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?redirect_uri=${HOST}/auth-google/&prompt=consent&response_type=id_token%20token&client_id=${GOOGLEID}&scope=email%20profile%20openid&flowName=GeneralOAuthFlow&nonce=${Math.random()}&fetch_basic_profile=true`;
};

export const gaEvent = (event_category: string, event_label: string) => {
  // @ts-ignore
  gtag('event', 'click', {event_category, event_label});
};

export const deviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "tablet";
  }
  else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return "mobile";
  }
  return "desktop";
};

export const isTC = (str: string) => {
  return str.split('').every(s => s.charCodeAt(0) >= 0x4E00 && s.charCodeAt(0) <= 0x9FA5);
};